var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenTile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 56,
    viewBox: "0 0 58 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9998 20.6117L46.9224 0.000183105L57.9997 20.6117H28.9998Z",
    fill: "#A8F55C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0001 20.6117L11.0774 0.000183105H46.9244L29.0017 20.6117H29.0001Z",
    fill: "#B9FF74"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9998 20.6115H57.9997L28.9998 55.1622V20.6115Z",
    fill: "#9CDF5A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 20.6115H0L11.0773 0L29 20.6115Z",
    fill: "#96DB51"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 55.1622L0 20.6115H29V55.1622Z",
    fill: "#A8F55C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_122_427",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 58,
    height: 56
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9998 20.6117L46.9224 0.000183105L57.9997 20.6117H28.9998Z",
    fill: "#ED1C24"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0001 20.6117L11.0774 0.000183105H46.9244L29.0017 20.6117H29.0001Z",
    fill: "#FF7676"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9998 20.6115H57.9997L28.9998 55.1622V20.6115Z",
    fill: "#AD1515"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29 20.6115H0L11.0773 0L29 20.6115Z",
    fill: "#EA292C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29 55.1622L0 20.6115H29V55.1622Z",
    fill: "#D5241C"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_122_427)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5907 14.1555L3.84824 32.3666L0.0585938 21.1819L53.801 2.97083L57.5907 14.1555Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1537 22.3068L0.508847 44.8908L-1.63354 38.5662L65.0113 15.9822L67.1537 22.3068Z",
    fill: "white"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M43.1246 12.3689C39.6779 12.3689 36.885 15.1619 36.885 18.6086C36.885 15.1619 34.092 12.3689 30.6453 12.3689C34.092 12.3689 36.885 9.57594 36.885 6.12921C36.885 9.57594 39.6779 12.3689 43.1246 12.3689Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTile);
export default __webpack_public_path__ + "static/media/green-tile.83ab1c46d394dc367bd6c55253d4b403.svg";
export { ForwardRef as ReactComponent };